import styled, { keyframes } from 'styled-components';

const animatePath = keyframes`
    from {
        stroke-dashoffset: ${props => props.pathLength};
    }

    to {
        stroke-dashoffset: 0;
    }
`;

const SVGStyledPath = styled.svg`
  animation: ${animatePath} ${props => props.theme.animation.duration} linear
    infinite;
  fill: none;
  height: ${props => props.theme.path.height};
  max-height: ${props => props.theme.path.maxHeightSM};
  max-width: ${props => props.theme.path.maxWidthSM};
  position: relative;
  stroke-dasharray: ${props => props.pathLength},
    ${props => props.pathLength / props.splits}, ${props => props.pathLength};
  stroke-dashoffset: ${props =>
    props.pathLength + props.pathLength / props.splits};
  stroke-linecap: ${props => props.theme.path.strokeLinecap};
  stroke-miterlimit: 10;
  stroke-width: ${props => props.theme.path.strokeWidth};
  width: ${props => props.theme.path.width};
  z-index: 1;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    stroke-width: ${props => props.theme.path.strokeWidthMedium};
  }

  /* max-width for block container (on medium screens) */
  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    max-height: ${props => props.theme.path.maxHeightMD};
    max-width: ${props => props.theme.path.maxWidthMD};
  }

  /* min-max-width for block container (on large screens) */
  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    max-height: ${props => props.theme.path.maxHeightLG};
    max-width: ${props => props.theme.path.maxWidthLG};
    min-height: 555px;
  }

  /* max-width for block container (on x-large screens) */
  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    max-height: ${props => props.theme.path.maxHeightXL};
    max-width: ${props => props.theme.path.maxWidthXL};
    min-height: 675px;
  }

  /* max-width for block container (on xx-large screens) */
  @media screen and (min-width: ${props => props.theme.breakpoints.xxl}) {
    max-height: ${props => props.theme.path.maxHeightXXL};
    max-width: ${props => props.theme.path.maxWidthXXL};
  }

  /* Portrait */
  @media screen and (max-width: ${props => props.theme.breakpoints.lg}) {
    &.landscape {
      display: none;
    }
    &.portrait {
      display: block;
    }
  }

  /* Landscape */
  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    stroke-width: ${props => props.theme.path.strokeWidthLarge};

    &.landscape {
      display: block;
    }
    &.portrait {
      display: none;
    }
  }
`;

export default SVGStyledPath;



// WEBPACK FOOTER //
// ./src/components/atoms/Path/Path.styled.js